import { createAction } from '@reduxjs/toolkit';
import { PedidoState } from './pedidoTypes';
import ProdutoNoPedido from '../../shared/entity/ProdutoNoPedido';
import Endereco from '../../shared/entity/Endereco';
import Cupom from '../../shared/entity/Cupom';
import ProdutoCompostoNoPedido from '../../shared/entity/ProdutoCompostoNoPedido';

export const setPedidoAction = createAction<PedidoState>('PEDIDO/SET');
export const addProdutoPedidoAction = createAction<ProdutoNoPedido>('PEDIDO/ADD');
export const delProdutoPedidoAction = createAction<number>('PEDIDO/DEL');
export const editProdutoPedidoAction = createAction<{ index: number; produto: ProdutoNoPedido }>(
  'PEDIDO/EDIT'
);
export const cleanPedidoAction = createAction<void>('PEDIDO/CLEAN');
export const setEnderecoAction = createAction<null | Endereco>('PEDIDO/ENDERECO');
export const setObservacaoAction = createAction<string>('PEDIDO/OBS');
export const setCupomAction = createAction<null | Cupom>('PEDIDO/CUPOM');

export const addProdutoCompostoPedidoAction = createAction<ProdutoCompostoNoPedido>(
  'PEDIDO/ADD_COMPOSTO'
);
export const delProdutoCompostoPedidoAction = createAction<number>('PEDIDO/DEL_COMPOSTO');
